<div>
    <iui-messages id="messages" #messages  class="ms-auto me-auto"></iui-messages>
  </div>
<p *ngIf="suspiciousActivityList?.length===0">No suspicious activities have been reported on any short codes.</p>
<div class="row mt-1 mb-4" *ngIf="suspiciousActivityList">
    <div class="col-12" *ngIf="!showUpdateActivityPanel">
        <p-table #tt styleClass="p-datatable-striped" id="tt" [value]="suspiciousActivityList" sortField="lastUpdate" [columns]="tableColumn" [scrollable]="true" scrollHeight="50vh"
            dataKey="activityId" [paginator]="true" [rows]="100" [filterDelay]="0"
            sortMode="single" [sortOrder]="-1" [alwaysShowPaginator]="false" (onFilter)="tableFiltered($event)"
            currentPageReportTemplate="(Displaying {first} to {last} of {totalRecords})" [showCurrentPageReport]="true"
            (onPage)="jumpToTop()" [globalFilterFields]="['shortCode']" (sortFunction)="customSort($event)" [customSort]="true">
            <ng-template pTemplate="caption">
                <div class="row header" *ngIf="suspiciousActivityList.length !== 0">
                    <div class="col-4">
                        <form class="search-bar-form" style="width: 100%;">
                            <input appNumericOnly maxlength="6" type="text" class="search-bar-input"
                                #globalSearch name="globalSearch" placeholder="Search for a Short Code" [(ngModel)]="shortCodeSearchInput"
                                (input)="tt.filterGlobal(shortCodeToNumeric($any($event.target).value), 'contains')">
                        </form>
                    </div>
                    <div class="col-4 justify-content-center filter-button-box">
                        <div class="center-horizontally-and-vertically ">
                                <button class="btn btn-primary me-2" (click)="toggleFilter();"
                                    id="shoHideBtn">{{filtersVisible ? "Hide Filters" : "Show Filters"}}</button>
                                <button *ngIf="filtersVisible" class="btn btn-secondary"
                                    (click)="clearFilter()" id="clearBtn">Clear Filters</button>
                        </div>
                    </div>
                </div>
            </ng-template>
            <ng-template pTemplate="header" let-columns>
                <tr *ngIf="suspiciousActivityList.length>0">
                    <th [style.width.%]="2"></th>
                    <ng-container *ngFor="let col of columns">
                        <!-- <th *ngIf="!col.sort" [style.width.%]="col.width" >{{col.header}}</th> -->
                        <th *ngIf="col.header==='Last Update' && col.sort" class="noBorder" [pSortableColumn]="col.field" sortOrder="desc" sortPriority="1" [style.width.%]="col.width" >
                            {{col.header}}
                            <p-sortIcon [field]="col.field"></p-sortIcon>
                        </th>
                        <th *ngIf="col.sort && col.header!=='Last Update' && col.header!=='Status'" class="noBorder"  [style.width.%]="col.width" [pSortableColumn]="col.field">
                            {{col.header}}
                            <p-sortIcon [field]="col.field"></p-sortIcon>
                        </th>
                        <th *ngIf="col.header==='Activity Type'" [pSortableColumn]="'activityType'">
                            <div class="d-flex justify-content-start align-items-center">
                                Activity Type
                                <i *ngIf="filterKeys.includes('activityType')" class="fa fa-filter icon-teal" aria-hidden="true"></i>
                                <p-sortIcon [field]="'activityType'"></p-sortIcon>
                            </div>
                        </th>
                        <th *ngIf="col.header==='Status' && col.sort" [pSortableColumn]="'status'">
                            <div class="d-flex justify-content-start align-items-center">
                                {{col.header}}
                                <i *ngIf="filterKeys.includes('status')" class="fa fa-filter icon-teal" aria-hidden="true"></i>
                                <p-sortIcon [field]="'status'"></p-sortIcon>
                            </div>
                        </th>
                    </ng-container>
                </tr>
                <tr *ngIf="filtersVisible">
                    <th class="list-header-filter"></th>
                    <th class="list-header-filter"></th>
                    <th class="list-header-filter"></th>
                    <th class="list-header-filter"></th>
                    <th class="list-header-filter">
                        <p-columnFilter #leeseeFil id="leeseeFil" field="lesseeCompany" matchMode="in" [showMenu]="false">
                            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                <p-multiSelect id="multiLeesee" appTid [ngModel]="value" [options]="allLeesee" placeholder="Select"
                                    appendTo="body" (onChange)="filter($event.value)"
                                    optionLabel="label" optionValue="value" selectedItemsLabel="{0} items selected"
                                    [maxSelectedLabels]="2" appendTo="body">
                                </p-multiSelect>
                            </ng-template>
                        </p-columnFilter>
                    </th>
                    <th class="list-header-filter">
                        <p-columnFilter #activityTypeFil id="activityTypeFil" field="activityTypes" matchMode="multi-select-in" [showMenu]="false">
                            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                <p-multiSelect id="multiActivity" appTid [ngModel]="value" [options]="allActivityType" placeholder="Select"
                                    appendTo="body" (onChange)="filter($event.value)"
                                    optionLabel="label" optionValue="value" selectedItemsLabel="{0} items selected"
                                    [maxSelectedLabels]="2" appendTo="body">
                                </p-multiSelect>
                            </ng-template>
                        </p-columnFilter>
                    </th>
                    <th class="list-header-filter"></th>
                    <th class="list-header-filter" *ngIf="showReportByColumn"></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex" let-columns="columns" let-expanded="expanded">
                <tr [pSelectableRow]="rowData" [pSelectableRowIndex]="rowIndex">
                    <td class="small-column-flex-override">
                        <button type="button"  pButton pRipple [pRowToggler]="rowData"
                            class="p-button-text p-button-rounded p-button-plain"
                            [icon]=" expanded ? 'fas fa-minus' : 'fas fa-plus'">
                        </button>
                    </td>
                    <td style="max-width: 300px;" *ngFor="let col of columns" class="noBorder" [ngSwitch]="col.field">
                        <div *ngSwitchCase="'lastUpdate'">
                            {{rowData.statuses[0].createTime | date:'M/d/yyyy'}}
                        </div>
                        <div *ngSwitchCase="'shortCode'" sortOrder="asc">
                            {{rowData.shortCode}}
                        </div>
                        <div *ngSwitchCase="'leesee'">
                            {{rowData.lesseeCompany}}
                        </div>
                        <div *ngSwitchCase="'activityType'" class="truncate" [pTooltip]="rowData.activityTypes.join(', ')" tooltipPosition="top" appShowToolTipIfTruncated>
                            {{rowData.activityTypes.join(', ')}}
                        </div>
                        <div *ngSwitchCase="'shared'" >
                            {{rowData.sharedShortCode? 'Shared' : ''}}
                        </div>
                        <div *ngSwitchCase="'status'">
                            <span *ngFor="let status of rowData.statuses">
                            <span *ngIf="status.latestStatus">{{status.status}}</span>
                            </span>
                        </div>
                        <div *ngSwitchDefault class="ellipsis">{{rowData[col.field]}}</div>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="rowexpansion" let-rowData let-rowIndex="rowIndex">
                <tr style="width: 99%;">
                    <td [attr.colspan]="10">
                        <div class=" col-12" style="margin-left: 20px;width:95%">
                            <span *ngFor="let status of rowData.statuses" class="margin50">
                                <span *ngIf="status.latestStatus && status.status==='Open' && rowData.createdByAccountId === loggedInUserAccountId">
                                    <button (click)="updateActivity(rowData)" class="btn btn-primary" id="updateActivity">Update Suspicious
                                        Activity Report</button>
                                </span>
                            </span>
                            <div class="ms-0 mb-1">
                                <strong>Content Provider Organization Name:</strong> {{rowData.cpCompanyName }}
                            </div>
                            <div class="ms-0 mb-1">
                                <strong>Direct Connection Aggregator Organization Name:</strong> {{ findAggregatorName(rowData.aggregatorId) }}
                            </div>
                            <div class="ms-0 mb-1">
                                <strong>Application Service Provider Organization Name:</strong> {{ rowData.applicationProvider }}
                            </div>
                            <div class="ms-0 mb-1">
                                <strong>Brand Client Organization Name:</strong> {{ rowData.brand}}
                            </div>
                            <div class="ms-0 mb-1 description">
                                <span><strong>Description:</strong></span>
                                <span><pre> {{ rowData.description }} </pre></span>
                            </div>
                            <div class="ms-0 mb-1">
                                <strong>Reported Date:</strong>
                                <span> {{ rowData.createTime | date:'M/d/yyyy h:mm a' }} </span>
                            </div>
                            <div class="ms-0 mb-1">
                                <strong>Status:</strong> <span *ngFor="let status of rowData.statuses">
                                    <span *ngIf="status.latestStatus"> {{status.status}}</span>
                                    </span>
                            </div>
                            <div class="ms-0 mb-1">
                                <strong>Comment:</strong> {{ rowData.statuses[0].comment}}
                            </div>
                        </div>
                    </td>
                </tr>
            </ng-template>
            <!-- <ng-template pTemplate="emptymessage" let-columns *ngIf="suspiciousActivityList.length>0">
                <tr>
                    <td [attr.colspan]="columns.length" class="noBorder">
                        <b>There is no history. {{listToShow}}</b>
                    </td>
                </tr>
            </ng-template> -->
        </p-table>
    </div>
    <div *ngIf="showUpdateActivityPanel">
        <form #form1="ngForm" name="activityStatusForm" (keydown.enter)="handleEnter($event)">
            <h4>Update Suspicious Activity</h4>
            <div class="padding-rem">
                <strong>Activity ID: {{selectedRowToUpdate.activityId}} </strong>
            </div>
            <div>
                <strong> Short Code: {{selectedRowToUpdate.shortCode}} </strong>
            </div>
            <div>
                <strong> Activity Types: {{(selectedRowToUpdate.activityTypes ?? []).join(', ')}} </strong>
            </div>
            <div class="padding-rem status">
                <label class="required" for="statusId">Status </label>
                <p-dropdown appDd [filter]="true" placeholder="Select Status"
                    [options]="statusOptions" name="status" id="statusId"
                    #statusId="ngModel" [(ngModel)]="model.status" [required]="true"></p-dropdown>
                <app-error-msg [field]="statusId" [fieldLabel]="'Activity Status'" [form]="form1"></app-error-msg>
            </div>
            <div class="padding-rem shared">
                <p-checkbox [(ngModel)]="model.sharedShortCode" name="sharedShortCode" (onChange)="onChangeSharedCheckbox($event)" [binary]="true"
                    id="sharedShortCode" label="Shared Short Code"> </p-checkbox>
            </div>
            <div class="padding-rem comment">
                <label class="required" for="comment">Comments </label>
                <textarea rows="10" name="comment" id="comment" cols="30" 
                    [(ngModel)]="model.comment" maxlength="2000" placeholder="Comments" #comment="ngModel" required 
                ></textarea>
                <app-error-msg [field]="comment" [fieldLabel]="'comment'" [form]="form1"></app-error-msg>
            </div>
            <div class="mt-3">
                <button (click)="updateSuspiciousActivity(form1)" class="btn btn-primary" id="updateSuspiciousActivity(form1)">Update</button>
                <button type="button" class="btn btn-secondary" id="reportActivityCancelId" style="margin-left:20px;" (click)="cancel(form1)">Cancel</button>
            </div>
        </form>
              </div>
    </div>
